var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"map",attrs:{"id":"map"}}),_c('div',{staticClass:"copy",on:{"click":_vm.copy}},[_vm._v("点击复制")])])
}
var staticRenderFns = []

export { render, staticRenderFns }